import { DashJSVideoPlayer } from "core.components";
import { Container, DependencyToken } from "./Container";
import { EventBus } from "./EventBus";
export const container = new Container();
// Event Bus
container.bindValue({
    value: new EventBus(),
    token: DependencyToken.EventBus,
});
container.bindFactory({
    token: DependencyToken.EventProducer,
    deps: [DependencyToken.EventBus],
    factory: (eventBus) => (data) => {
        eventBus.produce(data);
    },
});
// Video Player
container.bindValue({
    value: DashJSVideoPlayer,
    token: DependencyToken.VideoPlayer,
});
export default container;
//# sourceMappingURL=DefaultContainer.js.map